
<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import {getAxios} from "@/AxoisFactory"
@Options({
  components: {MainAppBar},
  data() {
    return {

    };
  },
  created() {
    console.log("mounted app")
    const axios = getAxios();
    axios.get("/gallery/categories").then((r: any) => {
      console.log(r);
      this.$store.commit("setPictureCategories", r.data);
    })
  },
  methods: {

  }
})
export default class App extends Vue {
}
</script>

<template>
    <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.playFairFont {
  font-family: 'Playfair Display', serif
}

.queensFont {
  font-family: 'Quintessential', cursive;
}
</style>
